import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../ui/button';
import BriqqLogo from '../brand/briqq-logo';
import { authService } from '../../services/auth';
import styles from './navbar.module.css';

interface NavbarProps {
  onOpenModal: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onOpenModal }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await authService.waitForInitialization();
        setIsAuthenticated(authService.isAuthenticated());
      } catch (error) {
        console.error('Error checking authentication:', error);
      }
    };

    checkAuth();

    // Listen for auth state changes
    const unsubscribe = authService.onAuthStateChanged((user) => {
      setIsAuthenticated(!!user);
    });

    return unsubscribe;
  }, []);

  const toggleMobileNav = () => {
    setMobileNavOpen(!mobileNavOpen);
  };

  const handlePageChange = (page: string) => {
    navigate(`/${page === 'home' ? '' : page}`);
    setMobileNavOpen(false);
  };

  const handleOpenModal = () => {
    onOpenModal();
    setMobileNavOpen(false);
  };

  return (
    <>
      <nav className={styles.nav}>
        <div className={styles.navContainer}>
          <button 
            onClick={() => handlePageChange('home')}
            className={styles.navBrand}
          >
            <BriqqLogo size="medium" showBeta={isAuthenticated} />
          </button>
          
          <ul className={styles.navMenu}>
            <li><button onClick={() => handlePageChange('home')} className={styles.navLink}>Homepage</button></li>
            <li><button onClick={() => handlePageChange('how-it-works')} className={styles.navLink}>How it Works</button></li>
            <li><button onClick={() => handlePageChange('pricing')} className={styles.navLink}>Pricing</button></li>
          </ul>
          
          <Button onClick={handleOpenModal} className={styles.navCta}>
            Join Briqq
          </Button>
          
          <div className={styles.mobileNavToggle} onClick={toggleMobileNav}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>

      <div className={`${styles.mobileNav} ${mobileNavOpen ? styles.open : ''}`}>
        <button onClick={() => handlePageChange('home')} className={styles.mobileNavLink}>Homepage</button>
        <button onClick={() => handlePageChange('how-it-works')} className={styles.mobileNavLink}>How it Works</button>
        <button onClick={() => handlePageChange('pricing')} className={styles.mobileNavLink}>Pricing</button>
        <button onClick={handleOpenModal} className={styles.mobileNavLink}>Join Briqq</button>
      </div>
    </>
  );
};

export default Navbar; 